import { alpha, type SxProps, type Theme } from "@mui/material";

export const EXPENSE_REVISION_AMBER = "#F59E0B";

export const expenseRevisionFieldSx: SxProps<Theme> = {
  "& .MuiOutlinedInput-root": {
    bgcolor: alpha(EXPENSE_REVISION_AMBER, 0.12),
  },
  "& .MuiInputLabel-root": {
    color: "warning.dark",
    fontWeight: 600,
  },
};

export const buildRevisionExpenseKeySet = (
  revisionExpenseKeys: string[] | undefined,
): Set<string> => {
  return new Set(revisionExpenseKeys ?? []);
};

export const isSingletonExpenseRevisionKey = (revisionKeys: Set<string>, type: string): boolean => {
  return revisionKeys.has(type);
};

export const isAdditionalExpenseRevisionKey = (
  revisionKeys: Set<string>,
  expenseId: string | undefined,
): boolean => {
  if (expenseId) {
    return revisionKeys.has(`additional-${expenseId}`);
  }
  return false;
};
